import React from 'react';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import clsx from 'clsx';
import { ButtonGridHeight } from '../buttons/ButtonGrid';

interface Props {
  xs?: any;
  sm?: any;
  md?: any;
  lg?: any;
  item?: any;
  justify?: any;
  onClick?: any;
  className?: any;
  style?: any;
  alignItems?: any;
  direction?: any;
  wrap?: any;
  classes?: any;
  withButtonGrid?: boolean;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    withButtonGrid: {
      [theme.breakpoints.down('xs')]: {
        marginBottom: ButtonGridHeight,
      },
    },
  }),
);

const Container: React.FC<Props> = ({
  xs,
  sm,
  md,
  lg,
  children,
  item,
  direction,
  justify,
  wrap,
  classes,
  alignItems,
  style,
  onClick,
  className,
  withButtonGrid,
}) => {
  const customClasses = useStyles();
  return (
    <Grid
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      container
      justifyContent={justify}
      item={item}
      alignItems={alignItems}
      spacing={0}
      direction={direction}
      wrap={wrap}
      classes={classes}
      style={style}
      onClick={onClick}
      className={clsx({
        [className]: className,
        [customClasses.withButtonGrid]: withButtonGrid,
      })}
    >
      {children}
    </Grid>
  );
};

Container.defaultProps = {
  item: false,
  justify: 'center',
  wrap: 'wrap',
};

export default Container;
